import axios from "axios";
export const API_URL = process.env.REACT_APP_API_URL;
export const authHeader = () => {
  const token = JSON.parse(localStorage.getItem("token"));
  if (token) {
    return { "x-access-token": token };
  } else {
    return {};
  }
};
export const login = async (username, clave, empresa) => {
  try {
    return new Promise((resolve, reject) => {
      axios
        .post(`${API_URL}/login`, {
          username,
          clave,
          empresa,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          resolve(error.response);
        });
    });
  } catch (error) {
    return null;
  }
};